import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'investment-amount-duration',
  templateUrl: './investment-amount-duration.component.html',
  styleUrls: ['./investment-amount-duration.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]],
    },
  ],
  standalone: false,
})
export class InvestmentAmountDurationComponent implements OnInit {
  @Input() derrors;
  @Input() isSwisslife = false;

  constructor(private controlContainer: FormGroupDirective) {}

  get form() {
    return this.controlContainer.form.get('parameters') as UntypedFormGroup;
  }
  monthlyAmountOptions: FormControlOption[] = [
    {
      label: '6 mois',
      value: 'MONTH_6',
    },
    {
      label: '9 mois',
      value: 'MONTH_9',
    },
    {
      label: '12 mois',
      value: 'MONTH_12',
    },
    {
      label: '18 mois',
      value: 'MONTH_18',
    },
    {
      label: '24 mois',
      value: 'MONTH_24',
    },
  ];
  ngOnInit() {
    if (!this.isSwisslife) {
      this.monthlyAmountOptions.push({
        label: 'au choix',
        value: 'CUSTOM',
      });
    }
    this.form
      .get('avOptionInvestissementProgressifDuree')
      .valueChanges.pipe(untilDestroyed(this))

      .subscribe(data => {
        if (data === 'CUSTOM') {
          this.form
            .get('avOptionInvestissementProgressifDureeCustom')
            .setValidators([Validators.required]);
          // update the form for trigger the validation
          this.form
            .get('avOptionInvestissementProgressifDureeCustom')
            .updateValueAndValidity();
        } else {
          // remove the validators
          this.form
            .get('avOptionInvestissementProgressifDureeCustom')
            .clearValidators();
          // update the form for trigger the validation
          this.form
            .get('avOptionInvestissementProgressifDureeCustom')
            .updateValueAndValidity();
        }
      });
  }
}
